﻿import { CenterOnOffPilot, CenterOrganType, DonorShieldStatus, YesNo } from '../../enums/index';
import { INewFileUpload } from './new-file-upload';
import { IVersionedFile } from './versioned-file';

export interface IAdminData {
    alias: string,
    dashDomain: string,

    userName: string,
    password: string,

    billingModel: string,

    rmcrFeeMajor: number,
    rmcrFeeMinor: number,
    rmcrIsContractFeeWaived: YesNo,
    overrideDonorsProtectedKidney: YesNo,
    overrideDonorsProtectedLiver: YesNo,
    monthlyFee: string,
    monthlyFeeNotes: string,
    dashFee: string,
    dashNotes: string,

    achRoutingNumber,
    achAccountNumber,

    organPackaging: number,
    packagingAchRoutingNumber,
    packagingAchAccountNumber: string,
    packagingAchApproved: YesNo,

    donorShieldFee: string,
    liverDonorShieldFee: string,

    transplantsCompleted: number,

    invoicePoNumber: string,
    poAmount: string,
    poBalance: string,
    invoicePoStartDate: string,
    invoicePoExpirationDate: string,
    invoiceDaysToRemit: string,

    nkrLiaisonId: number,
    executiveSponsorId: number,
    defaultMicrositeCoachUserId: number,

    isDeleted: YesNo,
    isTestCenter: YesNo,
    memberCenterType: CenterOrganType | null,
    isSuspended: YesNo,
    isMedicalBoard: YesNo,
    isAllIn: YesNo,
    isAdpPartner: YesNo,
    isDcnParticipant: YesNo,
    isFamilyVoucherParticipant: YesNo,

    isMicrositeParticipant: YesNo,
    isMicrositeReferralCenter: YesNo,
    useMicrositeResponsibilityConfirmation: YesNo,

    isDppParticipant: YesNo,
    isStreamlinedBilling: YesNo,
    isFollowUpParticipant: YesNo,
    isLiverDonorShieldARCenter: YesNo,
    dashType: CenterOrganType | null,
    isInDonorShield: DonorShieldStatus,
    isInactivityFeeWaived: YesNo,
    hasRecipientShield: YesNo,
    isGoldStar: YesNo,
    isDonorShieldDirectLiverCenter: YesNo,

    isInListingService: YesNo,
    isPrivate: YesNo,
    isBillableKidney: YesNo,
    isBillableLiver: YesNo,
    hasAgreedToFees: YesNo,
    paysUsViaAch: YesNo,

    isAcceptingReferrals: YesNo,
    isPatientReferralNetwork: YesNo,
    isMicrositeCenterOfExcellence: YesNo,
    isNutcrackerCenterOfExcellence: YesNo,
    nddReferrals: YesNo,
    isStrongBoxCenter: YesNo,

    excludeDataCompliance: YesNo,

    isRdnParticipant: YesNo,
    isAccParticipant: CenterOnOffPilot,
    hasCenterBilling: YesNo,
    ccbReviewDays: number,

    reduceEmails: YesNo,

    isUtilizing3gKidneyForLife: YesNo,
    doesAntibodyScreening: YesNo,
    getsFreeCheekSwabs: YesNo,
    isExpertSystemParticipant: YesNo,
    doesGraftFailureQuestions: YesNo,

    betaActivationStatus: CenterOnOffPilot,

    nkrBillingComments: string,

    files: ICenterFileType[],

    latitude?: number,
    longitude?: number
}

export interface ICenterFileType {
    typeId: number,
    type: string,
    newFile: INewFileUpload,
    files: IVersionedFile[]
}
